module.exports = __webpack_public_path__ + "remote_logo_abb.07c624aaec60f165a5a9392a9d244561.svg";